import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import React, { FC } from 'react'

const SuggestionChips: FC<{
  values: string[]
  selectedValues: string[]
  onToggle: (value: string) => void
  legendBackground?: string
}> = ({ values, selectedValues, onToggle, legendBackground }) => (
  <div className="condition_suggestions">
    <span className="condition_suggestions_legend" style={{ backgroundColor: legendBackground }}>予測候補</span>
    {
      values.map((value) => {
        const isActive = selectedValues.includes(value)
        return (
          <button
            type="button"
            className={`suggestion_chip ${isActive ? "active" : ""}`}
            key={`suggestion_${value}`}
            onClick={() => onToggle(value)}
          >
            <FontAwesomeIcon icon={['fas', isActive ? 'check' : 'plus']} fixedWidth />
            {value}
          </button>
        )
      })
    }
  </div>
)

export default SuggestionChips
